import {createContext} from 'react'; 

export const userInfoContext = createContext(null);//[{}, function(){}]
export const userListContext = createContext(null)